import { useEffect, useState, useRef } from "react";
import { SelectButton } from 'primereact/selectbutton';
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import { Button } from 'primereact/button';
import { Chip } from "primereact/chip";
import { Value } from "sass";
import { storage } from "../../helpers/storage";

const TallaCalzado = ({ alumno, handlePrenda, prendaConsulta, valueT }) => {

    const [selectButtonValue, setSelectButtonValue] = useState({});
    const [tallas, setTallas] = useState(null);
    const [prenda, setPrenda] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
    const [isDisabledDetete, setIsDisabledDelete] = useState(true);
    const [value, setValue] = useState([]);
    const [prendasElegidas, setPrendaElegida] = useState([]);
    const [idPrenda, setIdPrenda] = useState(null)

    const ciclo = storage.get('ciclo')

    const handleSelectionValue = prenda => {
        let value = []
        tallas.forEach(x => {
            if (x.IdPrenda === prenda.IdPrenda) {
                value = x.Tallas.find(talla => talla.IdTalla === prenda.IdTalla)
            }
        });
        // value = prenda;
        return value;
    }
    useEffect(() => {
        if(prendaConsulta.length !== 0){
            listaTallas(prendaConsulta)
        }
    }, [prendaConsulta])
    const arrPrendasTallas = [];
    const listaTallas = (consulta) => {
        // lst foreach idprenda 
        //IDPRenda  

        var strPrendaElegida = alumno.PrendaElegida;
        var arrPrendaElegida = Ordenar(JSON.parse(strPrendaElegida));

        arrPrendaElegida.map((i, index, arr) => {
            const response = consulta.filter(j => j.IdPrenda === i.IdPrenda && j.Genero === i.Genero && parseInt(j.CodigoTalla) === alumno.IdNivel).map(x => ({ ...x, Entregado: x.Entregado, dis: habilitarTallas(x) }))
            var selection = []
            selection = response.filter(x => parseInt(x.IdPrenda) === parseInt(i.IdPrenda) && x.Talla === i.Talla);
            setTallas(arrPrendasTallas);
            setPrendaElegida(arrPrendasTallas)
            setIdPrenda(i.IdPrenda)
            if (selection.length > 0) {
                handleTallaCalzado(selection[0], 0);
            }
            else {

                handleTallaCalzado(null, -1);
            }
            let arrpPrendasTallas = {
                IdPrenda: i.IdPrenda,
                Prenda: i.Prenda,
                Tallas: response,
                IdAlumno: alumno.IdAlumno,
                Entregado: i.Entregado,
                selection: selection.length > 0 ? selection : null,
                HabilitarEntregaParcial: i.HabilitarEntregaParcial,
                iconoRuta: i.Ruta
            };
            arrPrendasTallas.push(arrpPrendasTallas)
            setLoading(true)
        });

        // const arrSet = {
        //     "IdGenero": alumno.IdGenero,
        //     "IdNivel": alumno.IdNivel,
        //     "IdPrenda": 10
        // };

        // setLoading(true);
        // helpHttp().post(url, {
        //     body: arrSet,
        //     headers: {
        //         "Content-Type": "application/json; charset=utf-8",
        //         "Accept": "application/json",
        //         'Access-Control-Allow-Origin': '*',
        //         'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        //     },
        // }).then((res) => {
        //     setTallas(res);

        //     var strPrendaElegida = alumno.PrendaElegida;
        //     var arrPrendaElegida = JSON.parse(strPrendaElegida);

        //     // console.log(arrPrendaElegida);

        //     arrPrendaElegida.map(i => {

        //         console.log('I',i);
        //         var selection = res.filter(x => parseInt(x.IdPrenda) === parseInt(i.IdPrenda) && x.Talla === i.Talla);
        //         console.log('SELECCION',selection);
        //         if (selection.length > 0) {

        //             handleTallaCalzado(selection[0]);
        //         }
        //     });

        //var selection = res.filter(x => parseInt(x.IdPrenda) === 1 && parseInt(x.Talla) === parseInt(alumno.Calzado));
        //var mySelection = selection[0];

        /*var selection = res.filter(x => parseInt(x.IdPrenda) === 1 && parseInt(x.Talla) === parseInt(alumno.Calzado));
        var mySelection = selection[0];

        var selection = res.filter(x => parseInt(x.IdPrenda) === 1 && parseInt(x.Talla) === parseInt(alumno.Calzado));
        var mySelection = selection[0];*/

        /* if(alumno.Calzado != "") {
             selection.borrado = "noborrar";
             handleTallaCalzado(selection);
         } else {
             setIsDisabledDelete(false);
             setIsDisabled(false);
         }*/

        // });
        // setLoading(false);
    }

    useEffect(() => {

    }, [tallas]);
    useEffect(() => {

    }, [arrPrendasTallas, value]);

    //////////////////////////////////////////////////////
    function obtenerSeleccion(seleccion, PrendaElegida, index) {

        var prenda, talla, disponible;
        JSON.parse(PrendaElegida).map((x) => {

            if (x.IdPrenda === seleccion.IdPrenda) {
                prenda = x.Prenda
                talla = x.Talla
                disponible = x.PrendaDisponible === 0 ? 'No disponible' : 'Disponible'
            }

        })
        return (
            <>
                <label>Talla {talla}</label>

            </>
        )
    }


    /////////////////FUNCION PARA ORDENAR EN BASE AL ORDEN POLO-FALTA/JUMPER/PNT-CALZADO

    function Ordenar(paramsJson) {
        let arOrden = paramsJson;
        arOrden.sort(function (a, b) {
            return a.orden - b.orden;
        });
        return paramsJson

        // return paramsJson
    }
    /////////////////////////////////////////////////////////////////////////////////////
    ////////////////////FUNCION PARA HABILITAR O NO BTN DE TALLAS
    function habilitarTallas(Prenda, IdAlumno) {
        var dis;
        JSON.parse(alumno.PrendaElegida).map((p, index) => {
            if (p.IdPrenda === Prenda.IdPrenda) {
                if (p.Editable) {
                    dis = false;
                } else {
                    dis = true;
                }
            }
        })
        return dis
    }

    const handlePrendaEntrega = (selection, IdPrenda) => {

        const _selection = [...selection]
        const _tallas = [...tallas]
        const objIndex = _selection.findIndex(obj => obj.IdPrenda == IdPrenda);
        _selection[objIndex].Entregado = !_selection[objIndex].Entregado

        handleTallaCalzado(_selection[0], null)
    }

    const handleTallaCalzado = (selection, index) => {
        //si se selecciona la misma manda null
        if (selection === null && index !== -1) {
            selection = tallas[index].selection
        } else {

            if (tallas !== null && selection !== null) {
                const _tallas = [...tallas]
                const objIndex = _tallas.findIndex(obj => obj.IdPrenda == selection.IdPrenda);
                _tallas[objIndex].Tallas = _tallas[objIndex].Tallas.map(x => ({ ...x, Entregado: selection.Entregado }))
                _tallas[objIndex].selection = [selection]
                setValue(selection)
                setTallas(_tallas)

                valueT(selection)
                // tallas.map((x, index) => {
                //     if (tallas.length == 3) {

                //         if (x.IdPrenda == selection.IdPrenda) {
                //             //    var selection = x.filter(x => parseInt(x.IdPrenda) === parseInt(selection.IdPrenda) && x.Talla === selection.Talla);
                //             //    setTallas(arrPrendasTallas);
                //             x.Entregado = !x.Entregado
                //             x.selection = [selection]
                //             setValue(selection)
                //             setTallas(tallas)
                //             valueT(selection)
                //         }
                //     }
                // })
            }
            ////////////////////////////////////////////
            let arrSelection = {}
            let arrpPrendas = {}
            if (selection !== null && index !== -1) {

                var IdAlumno = alumno.IdAlumno;

                selection.IdAlumno = IdAlumno;
                selection.SerieEntregado = "0000000";


                arrpPrendas = {
                    IdPrenda: selection.IdPrenda,
                    Prenda: selection.Prenda,
                    Talla: selection.Talla,
                    Codigo: selection.Codigo,
                    Serie: selection.SerieEntregado,
                    Nivel: selection.Nivel,
                    IdAlumno: alumno.IdAlumno
                };

                arrSelection = {
                    IdPrenda: parseInt(selection.IdPrenda),
                    Prenda: selection.Prenda,
                    Codigo: selection.Codigo,
                    Genero: selection.Genero,
                    IdGenero: parseInt(selection.IdGenero),
                    Talla: selection.Talla,
                    IdTalla: selection.IdTalla,
                    Nivel: selection.Nivel,
                    Activo: selection.Activo,
                    Entregado: selection.Entregado,
                    IdAlumno: parseInt(IdAlumno),
                    SerieEntregado: "0000000",
                    Mensaje: selection.Mensaje,
                    success: true,
                    borrado: true
                }


            }
            handlePrenda(arrpPrendas, arrSelection, alumno.IdAlumno, alumno.IdEncEntrega, idPrenda);




        }
    }

    return (
        <>

            {


                tallas !== null &&
                tallas.sort((a, b) => a.IdPrenda > b.IdPrenda ? 1 : -1).map((x, index) => {
                    //  tallas.map(  (x,index) => {
                    return (

                        <div key={index} className="formgroup-inline" style={{display: 'block'}}>

                            <div className="field" style={{ marginBottom: '30px', marginRight: 0 }} >
                                <div className='flex'>
                                    <div className="col-1" style={{ alignSelf: 'center', paddingBottom: '13px' }}>
                                        <img style={{ width: '23px' }} src={`data:image/png;base64,${x.iconoRuta}`}/>
                                    </div>
                                    <div className="col-5 pr-0" style={{ paddingLeft: '15px' }}>
                                        <div style={{ fontWeight: '700' }}>{x.Prenda}</div>
                                        <div style={{ marginTop: '-3px', fontSize: '12px' }}>Solicitado: {obtenerSeleccion(x, alumno.PrendaElegida, index)}</div>
                                    </div>
                                    <div className="col-6 text-right pr-0 pl-0">

                                        <Button label={x.selection !== null ? x.selection[0].Entregado ? "Entregar" : "No entregar" : 'Entregar'}
                                            disabled={x.selection !== null ? x.HabilitarEntregaParcial === true ? false : true : true}
                                            icon={x.selection !== null ? x.selection[0].Entregado ? 'pi pi-check' : 'pi pi-times' : 'pi pi-check'}
                                            className={x.selection !== null ? x.selection[0].Entregado ? "hover:bg-green-100 font-medium" : "hover:bg-gray-400 font-medium" : "hover:bg-green-100 font-medium"}
                                            severity={x.selection !== null ? x.selection[0].Entregado ? "success" : "secondary" : "success"}
                                            rounded text style={x.selection !== null ? x.selection[0].Entregado ? { backgroundColor: '#e0f3e9' } : { backgroundColor: '#e5e5e5' } : { backgroundColor: '#e0f3e9' }}
                                            onClick={() => handlePrendaEntrega(x.selection, x.IdPrenda)} />
                                    </div>
                                </div>

                                <SelectButton
                                    id='btn_selec_talla'
                                    value={handleSelectionValue(x.selection !== null ? x.selection[0] : x.Tallas)}
                                    onChange={(e) => { handleTallaCalzado(e.value, index); }}
                                    options={x.Tallas}
                                    optionLabel="Talla"
                                    optionDisabled="dis"
                                />


                            </div>
                        </div>
                    )
                })

            }

        </>
    );
};

export default TallaCalzado;